import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {BUTTON_APP_CONFIG} from '@aviary/injection-tokens/app-provided.tokens';
import {ButtonAppConfig} from '@aviary/buttons/button.types';

export function provideAviaryButtonAppConfig(buttonAppConfig: ButtonAppConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: BUTTON_APP_CONFIG, useValue: buttonAppConfig}
  ]);
}
